import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SiteLaunchService {
  // Fallback date if config file fails to load
  public LAUNCH_DATE = '2026-06-11T00:44:00+05:30';

  private modalVisible = new BehaviorSubject<boolean>(false);
  public modalVisible$ = this.modalVisible.asObservable();

  private loginNotificationVisible = new BehaviorSubject<boolean>(false);
  public loginNotificationVisible$ = this.loginNotificationVisible.asObservable();

  constructor(private http: HttpClient) { }

  /**
   * Fetches the launch date from assets/launch-config.json.
   */
  public checkPreLaunchStatus(): Observable<boolean> {
    // Add cache buster to always fetch the newest JSON
    return this.http.get<any>(`assets/launch-config.json?t=${new Date().getTime()}`).pipe(
      tap((config: any) => {
        if (config && config.launchDate) {
          this.LAUNCH_DATE = config.launchDate;
        }
      }),
      map(() => this.isPreLaunchSync()),
      catchError((error) => {
        console.error('Could not load launch-config.json, using fallback date. Error:', error);
        return of(this.isPreLaunchSync());
      })
    );
  }

  public isPreLaunchSync(): boolean {
    const now = new Date();
    const launchDate = new Date(this.LAUNCH_DATE);
    return now < launchDate;
  }

  public showModal(): void {
    this.modalVisible.next(true);
  }

  public hideModal(): void {
    this.modalVisible.next(false);
  }

  public showLoginNotificationModal(): void {
    if (!environment.showLoginNotificationModal) {
      return;
    }
    this.loginNotificationVisible.next(true);
  }

  public hideLoginNotificationModal(): void {
    this.loginNotificationVisible.next(false);
  }

  /** In production, show the official notification modal and block navigation. */
  public blockInProduction(event?: Event): boolean {
    return false;
  }
}
